import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import logo from '@/assets/image/logo.png';


import { Switch } from '../../Switch';
import { LinkService } from '@/ui/_apiUrls';


export default function Link({ link, onEdit }: { link: any; onEdit: Function }) {
  const [checked, setChecked] = useState<boolean>(link.is_active ?? true);
  const queryClient = useQueryClient();

  const { mutate: patchLink, isLoading: isPatchingLink } = LinkService.patch({
    mutationParams: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['link'] });
      },
    },
  });

  useEffect(() => {
    setChecked(link.is_active ?? true);
  }, [link.is_active]);

  return (
    <>
      <div className="flex w-full flex-col gap-2 rounded-lg bg-white shadow-[0px_1px_2px_0px_#47546733]">
        <div className="flex items-center justify-between p-2 sm:w-full md:p-4">
          <div className="flex flex-1 items-center gap-3">
            <div className="w-[2.5rem] flex-shrink-0">
              <img src={link.thumbnail || logo} className="h-full w-[2.5rem] object-contain" alt="logo" />
            </div>
            <div className="ml-3 flex w-[8rem] flex-1 flex-col gap-1 overflow-hidden sm:flex-1">
              <p title={link.name} className="truncate break-words font-['Inter'] font-bold text-[13px] leading-[17px] text-[#475467]">
                {link.name}
              </p>
              <a
                className="w-full truncate break-words text-xs text-[#667085]"
                style={{ wordWrap: 'break-word' }}
                title={link.url}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {link.url}
              </a>
            </div>
          </div>
          <div className="flex flex-shrink-0 items-center justify-between gap-2">
            <button
              type="button"
              onClick={() => {
                if (onEdit) onEdit(link);
              }}
              className="p-1 hover:bg-gray-100 rounded transition-colors"
              aria-label={`Edit link: ${link.name}`}
            >
              <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7422 2.6875L11.5234 3.90625L9.02344 1.40625L10.2422 0.1875C10.3672 0.0625 10.5234 0 10.7109 0C10.8984 0 11.0547 0.0625 11.1797 0.1875L12.7422 1.75C12.8672 1.875 12.9297 2.03125 12.9297 2.21875C12.9297 2.40625 12.8672 2.5625 12.7422 2.6875ZM0.929688 9.5L8.30469 2.125L10.8047 4.625L3.42969 12H0.929688V9.5Z" fill="#989898"/>
              </svg>
            </button>
            <Switch
              onCheckedChange={(val) => {

                setChecked(val);
                patchLink({ id: link.id, is_active: val });
              }}
              checked={checked}
              disabled={isPatchingLink}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      </div>
    </>
  );
}
